import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface SeoOverrideData {
  meta_title: string | null;
  meta_description: string | null;
  og_image_url: string | null;
}

export function useSeoOverride(pagePath: string) {
  return useQuery({
    queryKey: ["seo-override", pagePath],
    queryFn: async (): Promise<SeoOverrideData | null> => {
      const { data, error } = await supabase
        .from("seo_overrides")
        .select("meta_title, meta_description, og_image_url")
        .eq("page_path", pagePath)
        .maybeSingle();
      if (error || !data) return null;
      return data as SeoOverrideData;
    },
    staleTime: 5 * 60 * 1000,
  });
}
